/* eslint-disable import/prefer-default-export */
import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/recaudacion/marcas-de-vehiculos/';

/**
 * GET Marca de Vehiculo
 * @returns {Promise<object||null>}
 */
export const getMarcaDeVehiculo = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * GET Marcas de Vehiculos
 * @returns {Promise<object[]>}
 */
export const getMarcasDeVehiculos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    if (response.data.results?.length) {
      return response.data;
    }
  } catch (err) {
    onError(err);
  }
  return { results: [] };
};

/**
 * POST Marcas de Vehiculos
 * @param {object} values
 * @returns {Promise<object[]>}
 */
export const postMarcasDeVehiculos = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * PATCH Marca de vehiculo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchMarcaDeVehiculo = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Marca de vehiculo
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteMarcaDeVehiculo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
